import React, { useState, useEffect, useRef } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isBefore,
  isToday,
} from "date-fns";
import "./Calendar.css"; // Ensure this matches your provided styles
import { FaCaretRight } from "react-icons/fa";
import { FaCaretLeft } from "react-icons/fa";
const HorizontalCalendar = ({
  selectedDate,
  onDateSelect,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
}) => {
  const [dates, setDates] = useState([]);
  const scrollRef = useRef(null);

  // Generate dates for the selected month & year (Right-to-Left & Exclude future dates)
  useEffect(() => {
    const today = new Date();
    const start = startOfMonth(new Date(selectedYear, selectedMonth));
    const end = endOfMonth(new Date(selectedYear, selectedMonth));
    const monthDates = eachDayOfInterval({ start, end })
      .filter((date) => isBefore(date, today) || isToday(date)) // Exclude future dates
      .reverse(); // Reverse order (Right to Left)

    setDates(monthDates);
  }, [selectedMonth, selectedYear]);

  // Scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  // Scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  // Ensure selected date is visible when clicked
  useEffect(() => {
    const activeBtn = document.querySelector(".date-btn.active");
    if (activeBtn) {
      activeBtn.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [selectedDate]);

  return (
    <div className="calendar-row flex-column flex-sm-column flex-md-column flex-lg-row">
      {/* Month & Year Selectors */}
      <div className="d-flex gap-2">
        <select
          className="form-select w-auto"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
        >
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i} value={i}>
              {format(new Date(2023, i, 1), "MMMM")}
            </option>
          ))}
        </select>

        <select
          className="form-select w-auto"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
        >
          {Array.from({ length: 5 }, (_, i) => {
            const year = new Date().getFullYear() - 2 + i;
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>
      </div>
      <div className="d-flex gap-2 align-items-center ">
        {/* Scroll Buttons */}
        <button className="scroll-btn left" onClick={scrollLeft}>
          {" "}
          <FaCaretLeft size={25} />{" "}
        </button>

        {/* Scrollable Horizontal Calendar */}
        <div ref={scrollRef} className="calendar-scroll">
          {dates.map((date) => (
            <button
              key={date.toString()}
              onClick={() => onDateSelect(date)}
              className={`date-btn ${format(date, "yyyy-MM-dd") === format(selectedDate, "yyyy-MM-dd")
                  ? "active"
                  : ""
                }`}
            >
              {format(date, "EEE")} <br />
              {format(date, "MMM dd")}
            </button>
          ))}
        </div>

        <button className="scroll-btn right" onClick={scrollRight}>
          <FaCaretRight size={25} />
        </button>
      </div>

    </div>
  );
};

export default HorizontalCalendar;
